<!--
 * @Author: your name
 * @Date: 2021-10-27 10:05:38
 * @LastEditTime: 2022-01-05 13:36:19
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\components\goods\goodsInfo.vue
-->
<template>
    <div class="detail_table_msg" :style="{ 'width': fromPage=='deliveryList'?'344px': widthValue}">
        <el-image lazy :src="goods.goodsPictureUrl" class="detail_table_image" @click="toProductDetail(goods.mallGoodsWarehouseId)">
            <div slot="error" class="image-slot">
                <img style="width:100%;height:100%" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/lazy_image.png"  @click="toProductDetail(goods.mallGoodsWarehouseId)" alt="">
            </div>
        </el-image>
        <div class="product_msg_con" @click="toProductDetail(goods.mallGoodsWarehouseId)">
            <el-tooltip class="item" effect="light" placement="bottom">
                <div slot="content">{{goods.showTitle}}</div>
                <h3 class="personal_product_title">{{goods.showTitle}}</h3>
            </el-tooltip>
            <p class="personal_product_p"  v-if="goods.brandName">品牌：{{goods.brandName}}</p>
            <p class="personal_product_p" v-if="goods.specification">规格：{{goods.specification}} </p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        };
    },
    props: {
        goods: {
            type: Object,
            default: {},
        },
        fromPage:'',
        widthValue:null
    },
    created(){
        
    },
    methods: {
        toProductDetail(mallGoodsWarehouseId){
            this.$router.push({ path: "/productDetail", query: {"mallGoodsWarehouseId":mallGoodsWarehouseId} });
        }
    }
};
</script>
<style scoped>
.detail_table_msg{
    width: 430px;
    text-align: center;
    height: 117px;
    display: flex;
    border-right: 1px solid #e2e2e2;
}
.detail_table_image{
    width: 81px;
    height: 81px;
    margin: 17px 11px 15px 17px;
    background-color: #F8F8F8;
    cursor: pointer;
}
.product_msg_con{
    width: calc(100% - 113px);
    text-align: left;
    margin: 17px 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/goods/goodsInfo.vue